import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { usePublicModuleByIdQuery } from '@entities/PublicModule';
import { PublicCardsBrowser, PublicModuleHero } from '@features/Library';
import { useIsSidebarMobile } from '@widgets/Sidebar';
import { paths } from '@shared/config';

export default function PublicModuleDetailPage() {
  const { t } = useTranslation();
  const mobile = useIsSidebarMobile();
  const { id } = useParams<{ id: string }>();
  const { data: module, isLoading } = usePublicModuleByIdQuery(id ?? null);

  if (isLoading) {
    return (
      <div className="lb lb--detail animate-fadeIn">
        <div className="h-5 w-48 animate-skeleton rounded bg-card" />
        <div className="mt-6 h-[180px] animate-skeleton rounded-[22px] bg-card" />
        <div className="mt-8 h-[320px] animate-skeleton rounded-[22px] bg-card" />
      </div>
    );
  }

  if (!module) {
    return (
      <div className="lb lb--detail animate-fadeIn text-center text-muted">
        {t('library.detail.notFound')}
      </div>
    );
  }

  return (
    <div className="lb lb--detail animate-fadeIn">
      <Link to={paths.wordsReady} className="lb-back">← {t('library.detail.back')}</Link>
      <PublicModuleHero module={module} />
      <PublicCardsBrowser cards={module.cards} mobile={mobile} />
    </div>
  );
}
